import { render, staticRenderFns } from "./SubItem.vue?vue&type=template&id=bb9cb37a&ref=container"
import script from "./SubItem.vue?vue&type=script&lang=js"
export * from "./SubItem.vue?vue&type=script&lang=js"
import style0 from "./SubItem.vue?vue&type=style&index=0&id=bb9cb37a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports